import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import './styles.css';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.eternavaults.com';

export default function NotificationBell() {
  const [familyNotifications, setFamilyNotifications] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const { getAccessTokenSilently } = useAuth0();

  const fetchFamilyNotifications = async () => {
    setLoading(true);
    try {
      const token = await getAccessTokenSilently();
      const response = await fetch(`${API_BASE_URL}/api/notifications/family`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      let family = [];
      if (response.ok) {
        family = await response.json();
      }
      setFamilyNotifications(family);
    } catch (error) {
      console.error('Error fetching family notifications:', error);
    } finally {
      setLoading(false);
    }
  };

  const getNotificationIcon = (type) => {
    switch (type) {
      case 'emergency_granted':
        return '🚨';
      case 'emergency_denied':
        return '⚠️';
      case 'emergency_failed':
        return '❌';
      case 'security':
        return '🔒';
      default:
        return '📢';
    }
  };

  const getNotificationColor = (type) => {
    switch (type) {
      case 'emergency_granted':
        return '#ff6b6b';
      case 'emergency_denied':
        return '#ff9800';
      case 'emergency_failed':
        return '#f44336';
      case 'security':
        return '#2196f3';
      default:
        return '#e2c89c';
    }
  };

  return (
    <div className="notification-bell-container">
      <button 
        className="notification-bell"
        onClick={() => {
          setShowDropdown(!showDropdown);
          if (!showDropdown) {
            fetchFamilyNotifications();
          }
        }}
      >
        🔔
      </button>

      {showDropdown && (
        <div className="notification-dropdown">
          <div className="notification-header">
            <h3>Family Notifications</h3>
          </div>
          <div className="notification-list">
            {loading ? (
              <div className="notification-loading">Loading...</div>
            ) : familyNotifications.length === 0 ? (
              <div className="no-notifications">No family notifications</div>
            ) : (
              familyNotifications.map(notification => (
                <div 
                  key={notification._id} 
                  className={`notification-item family-notification`}
                >
                  <div className="notification-icon" style={{ color: getNotificationColor(notification.type) }}>
                    {getNotificationIcon(notification.type)}
                  </div>
                  <div className="notification-content">
                    <div className="notification-title">{notification.title}</div>
                    <div className="notification-message">{notification.message}</div>
                    <div className="notification-time">
                      {new Date(notification.createdAt).toLocaleString()}
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      )}
    </div>
  );
} 